export const perimeters = (state) => state.perimeters
export const getRoomPerimeters = (state) => (id) => state.perimeters.filter(x => x.room_id === id) || []